module.exports = __webpack_public_path__ + "static/icon_tools_cooperatet_sprite.d05e303e.png";